export default __webpack_public_path__ + "static/media/02.ab558ed9.jpg";